import { NgModule } from '@angular/core';
import { ImportLocalLoadsComponent } from './import-local-loads/import-local-loads.component';
import { FindLoadsComponent } from './find-loads/find-loads.component';
import { LocalLoadsComponent } from './local-loads.component';
import { RouterModule } from '@angular/router';
import { LOCAL_LOADS_ROUTES } from './local-loads.routes';
import { SharedModule } from '../shared/shared.module';
import { LocalLoadService } from './shared/local-load.service';
import { ReorderLoadsService } from './shared/reorder-loads.service';
import { RowResultComponent } from './import-local-loads/row-result/row-result.component';
import { LoadDetailsComponent } from './find-loads/load-details/load-details.component';
import { FindLoadsListComponent } from './find-loads/find-loads-list/find-loads-list.component';
import { LocalLoadStatusComponent } from './local-load-status/local-load-status.component';
import { ReorderLoadsComponent } from './reorder-loads/reorder-loads.component';
import { VehicleLoadsListComponent } from './reorder-loads/vehicle-loads-list/vehicle-loads-list.component';
import { SearchLoadsListComponent } from './reorder-loads/search-loads-list/search-loads-list.component';
import { TmsImportResultComponent } from './import-local-loads/tms-import-result/tms-import-result.component';
import { TmsImportLoadListResultComponent } from './import-local-loads/tms-import-result/tms-import-load-list-result/tms-import-load-list-result.component';
import { TmsImportLoadResultComponent } from './import-local-loads/tms-import-result/tms-import-load-result/tms-import-load-result.component';
import { StopDetailsComponent } from './find-loads/stop-details/stop-details.component';
import { LoadEventsComponent } from './find-loads/load-events/load-events.component';
import { LoadEventStatusUpdateComponent } from './find-loads/load-events/load-event-status-update/load-event-status-update.component';
import { LoadEventCheckinComponent } from './find-loads/load-events/load-event-checkin/load-event-checkin.component';
import { LoadEventCheckoutComponent } from './find-loads/load-events/load-event-checkout/load-event-checkout.component';
import { LoadEventEtaUpdateComponent } from './find-loads/load-events/load-event-eta-update/load-event-eta-update.component';
import { LoadEventQuantityUpdateComponent } from './find-loads/load-events/load-event-quantity-update/load-event-quantity-update.component';
import { LoadEventVehicleAssignationComponent } from './find-loads/load-events/load-event-vehicle-assignation/load-event-vehicle-assignation.component';
import { LoadEventPodUploadComponent } from './find-loads/load-events/load-event-pod-upload/load-event-pod-upload.component';
import { LoadEventPictureUploadComponent } from './find-loads/load-events/load-event-picture-upload/load-event-picture-upload.component';
import { LoadEventNoteCreationComponent } from './find-loads/load-events/load-event-note-creation/load-event-note-creation.component';
import { LoadNoteTypeService } from './shared/load-note-type.service';
import { LoadCommunicationComponent } from './find-loads/load-communication/load-communication.component';
import { LocalNoteService } from './shared/local-note.service';
import { LocalLoadImportService } from './shared/local-load-import.service';
import { LoadEventManualItemAddedComponent } from './find-loads/load-events/load-event-manual-item-added/load-event-manual-item-added.component';
import { LocalLocationService } from './shared/local-location.service';
import { LocationsComponent } from './locations/locations.component';
import { LocationListComponent } from './locations/location-list/location-list.component';
import { LocationDetailComponent } from './locations/location-detail/location-detail.component';
import { PlantManagerLocationsComponent } from './locations/plant-manager-locations.component';
import { CreateLocalLoadComponent } from './create-local-load/create-local-load.component';
import { LoadEventCancelCheckinComponent } from './find-loads/load-events/load-event-cancel-checkin/load-event-cancel-checkin.component';
import { ReportsModule } from '../reports/reports.module';
import { LocationCarrierConfigurationEditComponent } from './locations/location-detail/location-carrier-configuration-edit/location-carrier-configuration-edit.component';
import { CoreModule } from '../core/core.module';
import { LocationSwitcherWrapperComponent } from './locations/modal-configuration/location-switcher-wrapper.component';

@NgModule({
    imports: [
        RouterModule.forChild(LOCAL_LOADS_ROUTES),
        SharedModule,
        ReportsModule,
        CoreModule,
    ],
    declarations: [
        ImportLocalLoadsComponent,
        LocalLoadsComponent,
        RowResultComponent,
        FindLoadsComponent,
        LoadDetailsComponent,
        FindLoadsListComponent,
        LocalLoadStatusComponent,
        ReorderLoadsComponent,
        VehicleLoadsListComponent,
        SearchLoadsListComponent,
        TmsImportResultComponent,
        TmsImportLoadListResultComponent,
        TmsImportLoadResultComponent,
        StopDetailsComponent,
        LoadEventsComponent,
        LoadEventStatusUpdateComponent,
        LoadEventCheckinComponent,
        LoadEventCheckoutComponent,
        LoadEventEtaUpdateComponent,
        LoadEventQuantityUpdateComponent,
        LoadEventVehicleAssignationComponent,
        LoadEventPodUploadComponent,
        LoadEventPictureUploadComponent,
        LoadEventNoteCreationComponent,
        LoadCommunicationComponent,
        LoadEventManualItemAddedComponent,
        LocationsComponent,
        LocationListComponent,
        LocationDetailComponent,
        LocationSwitcherWrapperComponent,
        PlantManagerLocationsComponent,
        CreateLocalLoadComponent,
        LoadEventCancelCheckinComponent,
        LocationCarrierConfigurationEditComponent
    ],
    exports: [
        LocalLoadStatusComponent
    ],
    providers: [
        LocalLoadService,
        LocalLoadImportService,
        LocalLocationService,
        LocalNoteService,
        LoadNoteTypeService,
        ReorderLoadsService
    ]
})
export class LocalLoadsModule {
}
